import React, { FC } from 'react';

import { Theme } from '@mui/material';
import { useTheme } from '@mui/styles';
import {
  CircularProgressProps as MuiCircularProgressProps
} from '@mui/material';

/* styled */
import { StyledCircularProgress } from './styled';

export const CircleProgress: FC<MuiCircularProgressProps> = (props) => {
  const theme: Theme = useTheme();
  return <StyledCircularProgress color={props.color} {...props} />;
};
